/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'

// component
import { Registration } from './components/Registration'
import { ForgotPassword }from './components/ForgotPassword'
import { Login } from './components/Login'
import { OPTCode } from './components/OPTCode'
import { ResetPassword } from './components/ResetPassword'
import { toAbsoluteUrl } from '../../../_jutemplate/helpers'
import { ForgotPasswordVerrify } from './components/ForgotPasswordVerrify'

//image
// import bg from "../../../assets/images/bg-images/AuthBgImage.png";


const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])
//bgGradient
  return (
   
      <div
        className="d-flex justify-content-center align-items-center bg-white h-100"
        // style={{
        //   backgroundImage: `url(${toAbsoluteUrl(bg)})`,
        //   backgroundSize: 'cover',
        //   backgroundPosition: 'center',
        //   height: '100vh',
        // }}
      >
    
          <div className="w-lg-500px bg-white rounded shadow p-10 p-lg-15 mx-auto" style={{maxWidth:'450px'}}>
              <Outlet />
          </div>
 
      </div>
   
  )
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path="login" element={<Login />} />
      <Route path="registration" element={<Registration />} />
      <Route path="forgot-password" element={<ForgotPassword/>} />
      <Route path="otp" element={<OPTCode />} />
      <Route path="reset-password" element={<ResetPassword />} />
      <Route
        path="forgot-password/:id"
        element={<ForgotPasswordVerrify />}
      />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export { AuthPage }
